// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 177 ? "home" : chunkId) + "." + {"12":"bf3c8def","157":"255c9ad9","177":"255c9ad9","189":"eff2ce00","639":"aecf6c24"}[chunkId] + ".css";
};